export const parseTime = (str) => {
    const split = str.split(":");
    return {
        hour  : +split[0],
        minute: +split[1],
    };
};
